<div>
    <h1>Locked out of system – too many failed attempts</h1>
</div>
<div class="icbc-alert-box icbc-alert-box-warning">
    <div>
        <mat-icon class="icbc-alert-icon">error_outline</mat-icon>
    </div>
    <div class="icbc-alert-box-warning-text">
        <div class="mb-8">
            We're sorry, but we're unable to verify the information you've
            provided. You’ve been locked out due to numerous invalid login
            attempts.
        </div>
        <div class="mb-8">
            Please try again after 24 hours or <a
                href=" http://www.icbc.com/about-icbc/contact-us/Pages/default.aspx"
                target="_blank" class="icbc-link">request your driving record</a> and/or insurance and
            claims history record in person, by phone or by mail.
        </div>
        <div class="mb-8">
            For any questions or concerns, please contact us at
            <strong>1-800-663-3051</strong>
        </div>
    </div>
</div>